// src/components/puzzle/PuzzlePiece.js
import React, { useRef, useEffect, useCallback } from 'react';
import useStore from '../../../../store';
import { renderOnePiece } from '../../renderers/renderOnePiece';

const PuzzlePiece = ({ 
  pieceId, 
  overrideStyle = {},
}) => {

  const puzzleRedraw = useStore(s => s.puzzleRedraw);

  const canvasPieceRef = useRef(null);
  const timerRef = useRef(null); // Реф для хранения ID таймера

  const store = useStore.getState();
  const { ref } = store;
  const { puzzle } = ref;
  const { state, config, boardTransform } = puzzle;

  const { isInitialized, pieces } = state;
  const piece = pieces?.[pieceId];

  

  // Выносим логику отрисовки в useCallback
  const renderPieceCanvas = () => {

    const { isInitialized, pieces, puzzleImageElement } = state;
    const piece = pieces?.[pieceId];

    // Убираем старый таймер, если он есть
    if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
    }

    // Условия для отрисовки
    if (!piece || !isInitialized || !puzzleImageElement) {

      console.warn(`Piece ${pieceId}: Conditions not met, retrying in 1s...`);
      timerRef.current = setTimeout(renderPieceCanvas, 1000);
      return; 
    }

    const canvas = canvasPieceRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const { basicTotalDimensions, screenTotalDimensions } = puzzle.methods.calculateOnePiece(pieceId);

    // Устанавливаем размеры канваса
    canvas.width = basicTotalDimensions.width;
    canvas.height = basicTotalDimensions.height;
    canvas.style.width = `${screenTotalDimensions.width * boardTransform.scale}px`;
    canvas.style.height = `${screenTotalDimensions.height * boardTransform.scale}px`;

    // Создаем кусочек пазла без вращения
    const pieceCanvas = renderOnePiece(piece, puzzleImageElement, {
      scale: 1,
      tabSizePercent: config.baseTabSizePercent,
    });

    // Очищаем canvas перед отрисовкой
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Рисуем не повернутый кусочек
    ctx.drawImage(pieceCanvas, 0, 0);

    // Применяем стили
    // 1. Стандартное вращение
    canvas.style.transform = `rotate(${piece.rotation}deg)`;
    // 2. Основные стили, переданные через проп style
    Object.assign(canvas.style, overrideStyle);
  

  };

  useEffect(() => {
    renderPieceCanvas(); 

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current); 
      }
    };

  }, [
    isInitialized,
    boardTransform.scale,
    config.user.trayHeight, 
  ]); // Зависимость useEffect - сама функция renderPieceCanvas

  if (!piece) {
    return null;
  }

  return (
    <canvas
      ref={canvasPieceRef}
    />
  );
};

export default PuzzlePiece;